import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("parent");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await register({ name, email, password, role });
      nav("/onboarding");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main
      className="min-h-screen grid place-items-center px-4 py-10"
      data-testid="register-page"
      style={{ background: "var(--tm-bg-2)" }}
    >
      <div className="w-full max-w-md tm-card">
        <h1 className="text-3xl font-black mb-2" style={{ fontFamily: "Nunito, sans-serif" }}>
          Create your account
        </h1>
        <p className="text-[color:var(--tm-ink-3)] mb-6">Parents and teachers welcome.</p>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label htmlFor="reg-name" className="tm-label">Your name</label>
            <input
              id="reg-name"
              type="text"
              required
              className="tm-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name-input"
            />
          </div>
          <div>
            <label htmlFor="reg-email" className="tm-label">Email</label>
            <input
              id="reg-email"
              type="email"
              required
              className="tm-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email-input"
            />
          </div>
          <div>
            <label htmlFor="reg-pw" className="tm-label">Password</label>
            <input
              id="reg-pw"
              type="password"
              required
              minLength={6}
              className="tm-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password-input"
            />
          </div>
          <div>
            <span className="tm-label">I am a</span>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setRole("parent")}
                className={`tm-btn ${role === "parent" ? "tm-btn-primary" : "tm-btn-outline"} flex-1`}
                data-testid="register-role-parent"
              >
                Parent
              </button>
              <button
                type="button"
                onClick={() => setRole("teacher")}
                className={`tm-btn ${role === "teacher" ? "tm-btn-primary" : "tm-btn-outline"} flex-1`}
                data-testid="register-role-teacher"
              >
                Teacher
              </button>
            </div>
          </div>
          {err && (
            <p className="text-sm font-medium" style={{ color: "var(--tm-error)" }} data-testid="register-error">
              {err}
            </p>
          )}
          <button type="submit" className="tm-btn tm-btn-primary w-full" disabled={busy} data-testid="register-submit-btn">
            {busy ? <Loader2 size={18} className="animate-spin" /> : null}
            Create account
          </button>
        </form>
        <p className="mt-6 text-sm text-center text-[color:var(--tm-ink-3)]">
          Already have an account?{" "}
          <Link to="/login" className="font-bold" style={{ color: "var(--tm-brand)" }} data-testid="register-login-link">
            Sign in
          </Link>
        </p>
      </div>
    </main>
  );
}
